import React, { useEffect, useState } from 'react';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../../components/bootstrap/Modal';
import Button from '../../../components/bootstrap/Button';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import { useFormik } from 'formik';
import {
	useGetCompanyProfileById,
	useGetPOCloseThreshold,
	useUpdateCompanyProfileById,
	useUpdatePOCloseThreshold,
} from '../../../apis/hooks/companyProfile';
import Icon from '../../../components/icon/Icon';
import { toast } from 'react-toastify';

interface Props {
	isOpen: boolean;
	toggle: () => void;
}

interface PrefixFormValues {
	validationRequisitionPrefix?: string;
	validationPurchaseOrderPrefix?: string;
	validationGRNPrefix?: string;
	validationQuotationPrefix?: string;
	validationPurchaseIndentPrefix?: string;
	validationPurchaseBillPrefix?: string;
	validationPaymentPrefix?: string;
	validationStaffPrefix?: string;
	validationPOCloseThreshold?: number;
	// validationBasic: number;
	// validationHRA: number;
	// validationTA: number;
	// validationDA: number;
	// validationAllowances: number;
	// validationPF: number;
	// validationPT: number;
	// validationDeductions: number;
}

const steps = [
	{
		title: 'QUOTE PREPARED',
		user: 'KishanD',
		date: '04-07-2025 04:10 PM',
		status: 'approved',
	},
	{
		title: 'AUTHO',
		user: 'KJ',
		date: '04-07-2025 04:10 PM',
		status: 'approved',
		info: 'Quotation',
		link: '#morbiFRQUO200540',
	},
	{
		title: 'FINAL AUTHO',
		status: 'pending',
		message: 'Pending approval!',
	},
];

const StatusStep = ({ step }: { step: any }) => (
	<div className='flex-fill text-center p-3 border rounded shadow-sm mx-2 bg-white'>
		<h6 className='fw-bold text-uppercase'>{step.title}</h6>
		{step.status === 'approved' ? (
			<Icon icon='Add' color='info' className='mb-2' />
		) : (
			<Icon icon='Cancel' color='danger' className='mb-2' />
		)}
		{step.user && (
			<div>
				by <strong>{step.user}</strong>
			</div>
		)}
		{step.date && <div className='text-muted small'>on {step.date}</div>}
		{step.info && (
			<div className='mt-1'>
				{step.info} <br />
				<a href={step.link} className='text-primary'>
					{step.link}
				</a>
			</div>
		)}
		{step.message && <div className='text-warning mt-2'>{step.message}</div>}
	</div>
);

const PrefixModal = ({ isOpen, toggle }: Props) => {
	const [isOpenn, setIsOpenn] = useState(false);

	const formik = useFormik<PrefixFormValues>({
		initialValues: {
			validationRequisitionPrefix: '',
			validationPurchaseOrderPrefix: '',
			validationGRNPrefix: '',
			validationQuotationPrefix: '',
			validationPurchaseIndentPrefix: '',
			validationPurchaseBillPrefix: '',
			validationPaymentPrefix: '',
			validationStaffPrefix: '',
			validationPOCloseThreshold: 0,
			// validationBasic: 0,
			// validationHRA: 0,
			// validationTA: 0,
			// validationDA: 0,
			// validationAllowances: 0,
			// validationPF: 0,
			// validationPT: 0,
			// validationDeductions: 0,
		},
		validate: (values) => {
			const errors: Partial<Record<keyof PrefixFormValues, string>> = {};
			// if (!values.validationCompanyId) errors.validationCompanyId = 'Required';
			return errors;
		},
		onSubmit: (values) => {
			const payload = {};
			console.log('Payload:', JSON.stringify(payload, null, 2));
		},
	});

	const { mutate: getCompanyProfileById, isPending } = useGetCompanyProfileById();
	const { mutate: getPOCloseThreshold } = useGetPOCloseThreshold();
	const { mutate: updateCompanyProfile } = useUpdateCompanyProfileById();
	const { mutate: updatePOCloseThreshold } = useUpdatePOCloseThreshold();

	const handleUpdate = () => {
		// const totalAllowances =
		// 	(formik.values.validationBasic || 0) +
		// 	(formik.values.validationHRA || 0) +
		// 	(formik.values.validationTA || 0) +
		// 	(formik.values.validationDA || 0) +
		// 	(formik.values.validationAllowances || 0);

		// if (totalAllowances !== 100) {
		// 	toast.error('Total of allowances must be exactly 100%', {
		// 		closeOnClick: true,
		// 		closeButton: true,
		// 	});
		// 	return; // Stop submission
		// } else {
		// 	console.log(totalAllowances);
		// }
		// updateCompanyProfile(
		// 	{
		// 		requisition_prefix: formik.values.validationRequisitionPrefix,
		// 		purchase_order_prefix: formik.values.validationPurchaseOrderPrefix,
		// 		grn_prefix: formik.values.validationGRNPrefix,
		// 		quotation_prefix: formik.values.validationQuotationPrefix,
		// 		purchase_indent_prefix: formik.values.validationPurchaseIndentPrefix,
		// 		purchase_bill_prefix: formik.values.validationPurchaseBillPrefix,
		// 		payment_prefix: formik.values.validationPaymentPrefix,
		// 		staff_code_prefix: formik.values.validationStaffPrefix,
		// 		basic: formik.values.validationBasic,
		// 		hra: formik.values.validationHRA,
		// 		ta: formik.values.validationTA,
		// 		da: formik.values.validationDA,
		// 		allowances: formik.values.validationAllowances,
		// 		pf: formik.values.validationPF,
		// 		pt: formik.values.validationPT,
		// 		deductions: formik.values.validationDeductions,
		// 	},
		// 	{
		// 		onSuccess: (res) => {
		// 			toggle();
		// 			toast.success(res?.message, {
		// 				closeOnClick: true,
		// 				closeButton: true,
		// 			});
		// 		},
		// 	},
		// );
		const payload = {
			requisition_prefix: formik.values.validationRequisitionPrefix,
			purchase_order_prefix: formik.values.validationPurchaseOrderPrefix,
			grn_prefix: formik.values.validationGRNPrefix,
			quotation_prefix: formik.values.validationQuotationPrefix,
			purchase_indent_prefix: formik.values.validationPurchaseIndentPrefix,
			purchase_bill_prefix: formik.values.validationPurchaseBillPrefix,
			payment_prefix: formik.values.validationPaymentPrefix,
			staff_code_prefix: formik.values.validationStaffPrefix,
			// basic: formik.values.validationBasic,
			// hra: formik.values.validationHRA,
			// ta: formik.values.validationTA,
			// da: formik.values.validationDA,
			// allowances: formik.values.validationAllowances,
			// pf: formik.values.validationPF,
			// pt: formik.values.validationPT,
			// deductions: formik.values.validationDeductions,
		};
		updateCompanyProfile(
			{
				requisition_prefix: formik.values.validationRequisitionPrefix,
				purchase_order_prefix: formik.values.validationPurchaseOrderPrefix,
				grn_prefix: formik.values.validationGRNPrefix,
				quotation_prefix: formik.values.validationQuotationPrefix,
				purchase_indent_prefix: formik.values.validationPurchaseIndentPrefix,
				purchase_bill_prefix: formik.values.validationPurchaseBillPrefix,
				payment_prefix: formik.values.validationPaymentPrefix,
				staff_code_prefix: formik.values.validationStaffPrefix,
			},
			{
				onSuccess: (res) => {
					toggle();
					toast.success(res?.message, {
						closeOnClick: true,
						closeButton: true,
					});
				},
			},
		);
		updatePOCloseThreshold({ threshold: formik.values.validationPOCloseThreshold })
		console.log('Payload:', JSON.stringify(payload, null, 2));
	};

	useEffect(() => {
		if (isOpen) {
			getCompanyProfileById(
				{},
				{
					onSuccess: (res: any) => {
						formik.setValues({
							validationRequisitionPrefix: res?.requisition_prefix ?? '',
							validationPurchaseOrderPrefix: res?.purchase_order_prefix ?? '',
							validationGRNPrefix: res?.grn_prefix ?? '',
							validationQuotationPrefix: res?.quotation_prefix ?? '',
							validationPurchaseIndentPrefix: res?.purchase_indent_prefix ?? '',
							validationPurchaseBillPrefix: res?.purchase_bill_prefix ?? '',
							validationPaymentPrefix: res?.payment_prefix ?? '',
							validationStaffPrefix: res?.staff_code_prefix ?? '',
							// validationBasic: res?.basic ?? '',
							// validationHRA: res?.hra ?? '',
							// validationTA: res?.ta ?? '',
							// validationDA: res?.da ?? '',
							// validationAllowances: res?.allowances ?? '',
							// validationPF: res?.pf ?? '',
							// validationPT: res?.pt ?? '',
							// validationDeductions: res?.deductions ?? '',
						});
					},
				},
			);
			getPOCloseThreshold(
				{}, {
				onSuccess: (res: any) => {
					formik.setFieldValue("validationPOCloseThreshold", res?.threshold ?? 0);
				},
			})
		}
	}, [isOpen]);

	return (
		<Modal
			isOpen={isOpen}
			onToggle={toggle}
			setIsOpen={toggle}
			isStaticBackdrop={true}
			isScrollable={true}
			isCentered={true}
			size={'xl'}
			isAnimation={true}
			showCloseIcon>
			<ModalHeader setIsOpen={toggle}>
				<ModalTitle id='exampleModalLabel' className='fs-3'>
					Settings
				</ModalTitle>
			</ModalHeader>
			<ModalBody>
				{/* <div className='d-flex justify-content-between gap-3'>
					{steps.map((step, index) => (
						<StatusStep step={step} key={index} />
					))}
				</div> */}
				{isPending ? (
					<p>Loading...</p>
				) : (
					<div className='row'>
						<h5 className='border-bottom '></h5>
						<h3 className='border-bottom py-2'>Prefix</h3>
						<div className='row g-3'>
							<FormGroup
								id='validationRequisitionPrefix'
								label='Requisition Prefix'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationRequisitionPrefix}
									isValid={formik.isValid}
									isTouched={formik.touched.validationRequisitionPrefix}
									invalidFeedback={formik.errors.validationRequisitionPrefix}
								/>
							</FormGroup>
							<FormGroup
								id='validationPurchaseOrderPrefix'
								label='Purchase Order Prefix'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationPurchaseOrderPrefix}
									isValid={formik.isValid}
									isTouched={formik.touched.validationPurchaseOrderPrefix}
									invalidFeedback={formik.errors.validationPurchaseOrderPrefix}
								/>
							</FormGroup>
							<FormGroup
								id='validationGRNPrefix'
								label='GRN Prefix'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationGRNPrefix}
									isValid={formik.isValid}
									isTouched={formik.touched.validationGRNPrefix}
									invalidFeedback={formik.errors.validationGRNPrefix}
								/>
							</FormGroup>
							<FormGroup
								id='validationQuotationPrefix'
								label='Quotation Prefix'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationQuotationPrefix}
									isValid={formik.isValid}
									isTouched={formik.touched.validationQuotationPrefix}
									invalidFeedback={formik.errors.validationQuotationPrefix}
								/>
							</FormGroup>
							<FormGroup
								id='validationPurchaseIndentPrefix'
								label='Purchase Indent Prefix'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationPurchaseIndentPrefix}
									isValid={formik.isValid}
									isTouched={formik.touched.validationPurchaseIndentPrefix}
									invalidFeedback={formik.errors.validationPurchaseIndentPrefix}
								/>
							</FormGroup>
							<FormGroup
								id='validationPurchaseBillPrefix'
								label='Purchase Bill Prefix'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationPurchaseBillPrefix}
									isValid={formik.isValid}
									isTouched={formik.touched.validationPurchaseBillPrefix}
									invalidFeedback={formik.errors.validationPurchaseBillPrefix}
								/>
							</FormGroup>
							<FormGroup
								id='validationPaymentPrefix'
								label='Payment Prefix'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationPaymentPrefix}
									isValid={formik.isValid}
									isTouched={formik.touched.validationPaymentPrefix}
									invalidFeedback={formik.errors.validationPaymentPrefix}
								/>
							</FormGroup>
							<FormGroup
								id='validationStaffPrefix'
								label='Staff Prefix'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationStaffPrefix}
									isValid={formik.isValid}
									isTouched={formik.touched.validationStaffPrefix}
									invalidFeedback={formik.errors.validationStaffPrefix}
								/>
							</FormGroup>
							<FormGroup
								id='validationPOCloseThreshold'
								label='PO Close Threshold'
								className='col-md-3'>
								<Input
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.validationPOCloseThreshold}
									isValid={formik.isValid}
									isTouched={formik.touched.validationPOCloseThreshold}
									invalidFeedback={formik.errors.validationPOCloseThreshold}
								/>
							</FormGroup>
						</div>
					</div>
				)}
			</ModalBody>
			<ModalFooter>
				<Button
					color='info'
					icon='Save'
					isOutline
					type='submit'
					onClick={() => handleUpdate()}>
					Save
				</Button>
				<Button
					color='danger'
					icon='cancel'
					isOutline
					onClick={toggle} // ✅ Now closes modal
				>
					Cancel
				</Button>
			</ModalFooter>
		</Modal>
	);
};

export default PrefixModal;
